<!--
 * @Description: 线索管理详情
 * @Author: cxh
 * @Date: 2022-05-24 15:19:34
 * @LastEditTime: 2023-05-05 10:43:43
 * @LastEditors: cxh
-->
<template>
  <dc-layout-main>
    <dc-layout-content>
      <CosViewContent>
        <a-tabs @change="changeTabs" v-model:activeKey="activeKey">
          <a-tab-pane key="base" tab="基本信息">
            <baseMessage
              ref="baseMessageRef"
              :content="['expectPushInfo']"
              disabled
              view
              :permissionPage="permissionBase"
              @detail="getDetail"
            />
          </a-tab-pane>
          <a-tab-pane key="contact" tab="联系人">
            <TabsContacts
              ref="contactsRef"
              appId="cos_zbu"
              :contactRefId="route.query.clueId"
              :trackAcceptorClueId="route.query.trackAcceptorClueId"
              :permissionPage="permissionConcat"
            />
          </a-tab-pane>
          <a-tab-pane key="tabsFollowUp" tab="跟进情况">
            <TabsClueCosFollowUp appId="cos_zbu_fbu" :followRefId="route.query.trackAcceptorClueId" />
          </a-tab-pane>
          <a-tab-pane key="tabsTrack" tab="跟踪情况">
            <TabsTrack :data="detail.track?.trackDetail" />
          </a-tab-pane>
          <a-tab-pane key="operationLog" tab="操作日志">
            <TabsOperationLog
              ref="operationLogRef"
              tableId="ZbuClueManageOperationLog"
              :resourceId="route.query.clueId"
              appId="cos_zbu"
            />
          </a-tab-pane>
        </a-tabs>
      </CosViewContent>
      <ViewFooterBtn :permissionPage="permissionBase" @success="footerSuccess" :detail="detail" />
    </dc-layout-content>
  </dc-layout-main>
</template>
<script setup lang="ts">
import { ref } from 'vue'
import baseMessage from '../../components/baseMessage.vue'
import TabsOperationLog from '@/components/TabsOperationLog/index.vue'
import TabsContacts from '@/components/TabsContacts/index.vue'
import ViewFooterBtn from '../../components/viewFooterBtn.vue'
import TabsClueCosFollowUp from '@/components/TabsClueCosFollowUp/src/zbu.vue'
import TabsTrack from '../../components/tabsTrack.vue'
import { useRoute } from 'vue-router'
const route = useRoute()
const activeKey = ref('base')
const operationLogRef = ref()
const detail = ref({})
// 标签页切换
const baseMessageRef = ref()
const contactsRef = ref()
const changeTabs = (v: string) => {
  switch (v) {
    case 'base':
      baseMessageRef.value?.fetch()
      break
    case 'contact':
      contactsRef.value?.refresh()
      break
    case 'operationLog':
      operationLogRef.value?.fetch()
      break
  }
}
const getDetail = (v: any) => {
  detail.value = v
}
const footerSuccess = (tag: 'contact') => {
  if (tag === 'contact') {
    // 更新联系人或者操作日志
    if (activeKey.value === 'contact') {
      contactsRef.value?.refresh()
    } else if (activeKey.value === 'operationLog') {
      operationLogRef.value?.fetch()
    }
  }
}
const permissionBase = {
  edit: 'fbu_lead_edit_btn',
  concat_add: 'fbu_lead_concat_add_btn'
}
const permissionConcat = {
  add: 'fbu_lead_concat_add_btn',
  edit: 'fbu_lead_concat_edit_btn',
  del: 'fbu_lead_concat_del_btn',
  push: 'fbu_lead_concat_push_btn'
}
</script>
